import loaderLeaf from '@assets/images/common/loader_leaf.png';
import { useTranslation } from 'react-i18next';

export function DashboardLoading() {
  const { t } = useTranslation();

  return (
    <div className="flex h-full w-full flex-col items-center justify-center bg-white">
      <img src={loaderLeaf} alt="" width={80} height={80} />
      <p className="typo typo--title-2 text-sy-neutral-100">
        {t('intelligence_dashboard.loading')}
      </p>
    </div>
  );
}

export default DashboardLoading;
